import { render, staticRenderFns } from "./NewEstateInfo.vue?vue&type=template&id=438a2048&scoped=true&"
import script from "./NewEstateInfo.vue?vue&type=script&lang=js&"
export * from "./NewEstateInfo.vue?vue&type=script&lang=js&"
import style0 from "./NewEstateInfo.vue?vue&type=style&index=0&id=438a2048&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438a2048",
  null
  
)

export default component.exports